import api from './api';
import API_ROUTES from './apiRoutes';

// Helper to get the correct API routes based on user role
const getNotificationRoutes = (role) => {
  if (role === 'player') {
    return {
      getNotifications: API_ROUTES.PLAYER.GET_NOTIFICATIONS,
      markAsRead: (id) => API_ROUTES.PLAYER.MARK_NOTIFICATION_READ(id),
      markAllAsRead: API_ROUTES.PLAYER.MARK_ALL_NOTIFICATIONS_READ,
    };
  }
  // Default to superAdmin routes for admin/superAdmin
  return {
    getNotifications: API_ROUTES.SUPER_ADMIN.GET_NOTIFICATIONS,
    markAsRead: (id) => API_ROUTES.SUPER_ADMIN.MARK_NOTIFICATION_READ(id),
    markAllAsRead: API_ROUTES.SUPER_ADMIN.MARK_ALL_NOTIFICATIONS_READ,
  };
};

const notificationService = {
  // Get all notifications
  getNotifications: async (params = {}, role = 'superAdmin') => {
    const { page = 1, limit = 10 } = params;
    const routes = getNotificationRoutes(role);
    const response = await api.get(routes.getNotifications, {
      params: { page, limit },
    });
    return response.data;
  },

  // Get notification settings (superAdmin only)
  getNotificationSettings: async () => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_NOTIFICATION_SETTINGS);
    return response.data;
  },

  // Update notification settings (superAdmin only)
  updateNotificationSettings: async (triggers) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_NOTIFICATION_SETTINGS, {
      triggers,
    });
    return response.data;
  },

  // Mark notification as read
  markAsRead: async (notificationId, role = 'superAdmin') => {
    const routes = getNotificationRoutes(role);
    const response = await api.patch(routes.markAsRead(notificationId));
    return response.data;
  },

  // Mark all notifications as read
  markAllAsRead: async (role = 'superAdmin') => {
    const routes = getNotificationRoutes(role);
    const response = await api.patch(routes.markAllAsRead);
    return response.data;
  },
};

export default notificationService;
